import { render, staticRenderFns } from "./aicaigou.vue?vue&type=template&id=423201ce&scoped=true"
import script from "./aicaigou.vue?vue&type=script&lang=js"
export * from "./aicaigou.vue?vue&type=script&lang=js"
import style0 from "./aicaigou.vue?vue&type=style&index=0&id=423201ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423201ce",
  null
  
)

export default component.exports